import { useEffect, useState } from 'react'
import BordFilterCard from './CommonComponent/BordFilterCard'
import BordMegementHeader from './CommonComponent/BordMegementHeader'
import BoardManagmentTable from './CommonComponent/BoardManagmentTable'
import api from '@/services/api'
import { useDebounce } from '@/hooks/useDebounce'

import BordAddandEditDialogComponent from './CommonComponent/BordAddandEditDialogComponent'
import BordDeleteDialogComponent from './CommonComponent/BoradDeleteDialogComponent'
import ActiveInactiveComponent from './CommonComponent/BoradActiveInactiveComponent'
import { IconButton, Pagination, Tooltip } from '@mui/material'
import RowsPerPageDropdown from '../RowsPerPageDropdown'
import UploadCsv from './CommonComponent/UploadCsv'
import ExportCsv from './CommonComponent/ExportCsv'
import { EditIcon } from 'lucide-react'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import ToggleOffIcon from '@mui/icons-material/ToggleOff'
import ReusableTable from '@/components/ReusableTable/ReusableTable'
import { fr } from 'date-fns/locale'
import toast from 'react-hot-toast'

const LicenseType = () => {
  const prevSize = sessionStorage.getItem('prevSize')
  const ourPageSize = prevSize ? parseInt(prevSize, 10) : 10
  const [boardData, setBoardData] = useState<any[]>([])
  const [loadingForShimmer, setLoadingForShimmer] = useState(false)
  const [pageSize, setPageSize] = useState(10)
  const [totalRecords, setTotalRecords] = useState(0)
  const [totalPages, setTotalPages] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const [searchKeyword, setSearchKeyword] = useState('')
  const debouncedSearch = useDebounce(searchKeyword, 500)
  const [openDialog, setOpenDialog] = useState(false)
  const [addDialogLoading, setAddDialogLoading] = useState(false)
  const [deleteDialog, setDeleteDialog] = useState(false)
  const [deleteLoading, setDeleteLoading] = useState(false)
  const [selectedBoardForDelete, setSelectedBoardForDelete] =
    useState<any>(null)
  const [openToggle, setOpenToggle] = useState(false)
  const [toggleData, setToggleData] = useState<any>(null)
  const [filterValues, setFilterValues] = useState({
    slNo: '',
    category: '',
    search: '',
  })
  const [formData, setFormData] = useState({
    sl_no: '',
    category: '',
    task: '',
    name: '',
    description: '',
  })
  const [editData, setEditData] = useState<any>(null)
  const [sortField, setSortField] = useState<any>("")
  const [sortOrder, setSortOrder] = useState("asc")

  const licenseTypeFields: Array<{
    name: string
    label: string
    placeholder: string
    required: boolean
    type?: 'text' | 'textarea' | 'select' | 'number'
    rows?: number
    options?: Array<{ label: string; value: string }>
  }> = [
    ...(editData ? [{
      name: 'sl_no',
      label: 'SL NO.',
      placeholder: 'Enter SL NO.',
      required: false,
      type: 'number' as const,
    }] : []),
    {
      name: 'category',
      label: 'Category',
      placeholder: 'Enter Category',
      required: true,
      type: 'select',
      options: [
        { label: 'Therapist', value: 'Therapist' },
        { label: 'Skilled Nurse', value: 'Skilled Nurse' },
        { label: 'Caregiver', value: 'Caregiver' },
      ],
    },
    {
      name: 'task',
      label: 'License Task',
      placeholder: 'Enter License Task',
      required: true
    },
    {
      name: 'name',
      label: 'License Title',
      placeholder: 'Enter License Title',
      required: true
    },
    {
      name: 'description',
      label: 'Description',
      placeholder: 'Enter Description',
      required: true,
      type: 'textarea',
      rows: 4
    }
  ]

  const licenseTypeFilterFields = [
    {
      name: 'search',
      label: 'Search',
      type: 'text' as const,
      placeholder: 'Search...'
    },
    {
      name: 'category',
      label: 'Category',
      type: 'select' as const,
      options: [
        { label: 'All', value: '' },
        { label: 'Therapist', value: 'Therapist' },
        { label: 'Skilled Nurse', value: 'Skilled Nurse' },
        { label: 'Caregiver', value: 'Caregiver' },
      ],
      placeholder: 'Search by Category'
    },
    
  ]

  const handleFilterChange = (filterName: string, value: any) => {
    setFilterValues({ ...filterValues, [filterName]: value })
    setCurrentPage(1)
  }

  useEffect(() => {
    fetchBoardName(currentPage)
  }, [debouncedSearch, pageSize, currentPage, sortField, sortOrder, filterValues])

  const fetchBoardName = async (page?: number) => {
    setLoading(true)
    setError('')
    try {
      setLoadingForShimmer(true)
      const params: Record<string, any> = {
        page: page || currentPage,
        limit: pageSize,
      }

      if (searchKeyword?.trim()) {
        params.search = searchKeyword
      }
      if (filterValues.slNo) {
        params.slNo = filterValues.slNo
      }
      if (filterValues.category?.trim()) {
        params.category = filterValues.category
      }
      if (filterValues.search?.trim()) {
        params.search = filterValues.search
      }
      if (sortField) {
        params.sortField = sortField
        params.sortOrder = sortOrder
      }


      const response = await api.get(`boards/licensetype/list`, {
        params,
      })

      if (response?.data?.data) {
        setBoardData(response?.data?.data)
      } else {
        setError('No patients data found')
      }

      const pagination = response?.data?.pagination
      if (pagination) {
        setTotalPages(Number(pagination.totalPages) || 1)
        setTotalRecords(Number(pagination.total) || 0)
      } else {
        const recordsCount =
          response?.data?.totalRecords ||
          response?.data?.stats?.totalBoards ||
          0
        setTotalRecords(recordsCount)
        setTotalPages(Math.ceil(recordsCount / pageSize) || 1)
      }
    } catch (err: any) {
      console.error(err)
      setError('Failed to fetch patients')
    } finally {
      setLoadingForShimmer(false)
      setLoading(false)
    }
  }

  const handleOpenDialog = () => {
    setEditData(null)
    setFormData({ sl_no: '', category: '', task: '', name: '', description: '' })
    setOpenDialog(true)
  }

  const handleEditBoard = (board: any) => {
    setEditData(board)
    setFormData({
      sl_no: board.sl_no || '',
      category: board.category || '',
      task: board.task || '',
      name: board.name || '',
      description: board.description || '',
    })
    setOpenDialog(true)
  }

  const handleCloseDialog = () => {
    setOpenDialog(false)
    setEditData(null)
    setFormData({ sl_no: '', category: '', task: '', name: '', description: '' })
  }

  const handleSubmit = async () => {
   
    if (!formData.category) {
      toast.error('Please enter category')
      return
    }
    if (!formData.task?.trim()) {
      toast.error('Please enter license tasks')
      return
    }
    if (!formData.name) {
      toast.error('Please enter license title')
      return
    }
    if (!formData.description) {
      toast.error('Please enter description')
      return
    }
    

    // Include all fields in payload
    const payload = { ...formData }

    try {
      if (editData) {
        setAddDialogLoading(true)
        const response = await api.patch(
          `boards/licensetype/${editData._id}`,
          payload
        )
        if (response.status === 200) {
          toast.success('License Type updated successfully')
          handleCloseDialog()
          fetchBoardName()
        }
      } else {
        setAddDialogLoading(true)
        const response = await api.post('boards/licensetype', payload)
        if (response.status === 201) {
          toast.success('License Type added successfully')
          handleCloseDialog()
          fetchBoardName()
        }
      }
    } catch (error: any) {
      console.error('Error adding board:', error)
      toast.error(error?.response?.data?.message || 'Failed to save license type')
    } finally {
      setAddDialogLoading(false)
    }
  }

  const handleCloseDeleteDialog = () => {
    setDeleteDialog(false)
  }

  const handleConfirmDelete = async () => {
    if (!selectedBoardForDelete) {
      toast.error('No board selected for deletion')
      return
    }

    try {
      setDeleteLoading(true)
      const response = await api.delete(
        `boards/licensetype/${selectedBoardForDelete._id}`
      )
      if (response.status === 200) {
        toast.success('Board deleted successfully')
        handleCloseDeleteDialog()
        fetchBoardName()
      }
    } catch (error: any) {
      console.error('Error deleting board:', error)
      toast.error(error?.response?.data?.message || 'Failed to delete board')
    } finally {
      setDeleteLoading(false)
    }
  }

  const handleCloseToggle = () => {
    setOpenToggle(false)
  }

  const handleConfirmToggle = async () => {
    if (!toggleData) {
      toast.error('No board selected for toggle')
      return
    }

    try {
      setLoading(true)

      const response = await api.patch(`boards/licensetype/${toggleData._id}`, {
        isActive: !toggleData.isActive,
      })
      if (response.status === 200) {
        toast.success('Board status updated successfully')
        handleCloseToggle()
        fetchBoardName()
      }
    } catch (error: any) {
      console.error('Error toggling board:', error)
      toast.error(error?.response?.data?.message || 'Failed to toggle board')
    } finally {
      setLoading(false)
    }
  }

  const handleReset = () => {
    setSearchKeyword('')
  }

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setCurrentPage(page)
  }

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize)
    setCurrentPage(1)
    sessionStorage.setItem('prevSize', newPageSize.toString())
  }

  const columns = [
    {
      header: 'SL NO.',
      accessor: 'sl_no',
      sortable: true,
    },
    {
      header: 'CATEGORY',
      accessor: 'category',
      sortable: true,
    },
    {
      header: 'TASK',
      accessor: 'task',
      sortable: true,
    },
    {
      header: 'Title',
      accessor: 'name',
      sortable: true,
    },
    

    {
      header: 'DESCRIPTION',
      accessor: 'description',
      sortable: false,
    },

    {
      header: 'ACTIONS',
      render: board => (
        <div className="flex items-center justify-center gap-1">
          <Tooltip placement="top" title={board?.isActive ? 'Deactivate' : 'Activate'} arrow>
            <IconButton
              onClick={() => {
                setToggleData(board)
                setOpenToggle(true)
              }}
            >
              {board?.isActive ? (
                <ToggleOnIcon sx={{ fontSize: 32, color: '#10b981' }} />
              ) : (
                <ToggleOffIcon sx={{ fontSize: 32, color: '#ef4444' }} />
              )}
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title="Edit" arrow>
            <IconButton
              onClick={() => handleEditBoard?.(board)}
              sx={{ color: '#10b981' }}>
              <EditIcon />
            </IconButton>
          </Tooltip>

          <Tooltip placement="top" title="Delete" arrow>
            <IconButton
              onClick={() => { setSelectedBoardForDelete(board); setDeleteDialog(true) }}
              sx={{ color: '#dc2626' }}>
              <DeleteForeverIcon />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ]

  const handleSort = (field: string) => {
    let order = "asc"

    if (sortField === field) {
      order = sortOrder === "asc" ? "desc" : "asc"
    }

    setSortField(field)
    setSortOrder(order)
  }

  return (
    <div>
      <BordMegementHeader
        handleOpenDialog={handleOpenDialog}
        title="License Type"
        buttonText="Add License Type"
      >
        <UploadCsv
          apiUrl="boards/upload-licensetype-csv"
          title="Import License Type"
          licenseType
        />

        <ExportCsv
          apiUrl="boards/export-licensetype"
          fileName="license_type.csv"
        />
      </BordMegementHeader>
      
      <BordFilterCard
        searchLabel="Search Name"
        search={searchKeyword}
        setSearchKeyword={val => {
          setSearchKeyword(val)
          setCurrentPage(1)
        }}
        handleReset={() => {
          handleReset()
          setFilterValues({ slNo: '', category: '', search: '' })
          setCurrentPage(1)
        }}
        filters={licenseTypeFilterFields}
        filterValues={filterValues}
        onFilterChange={handleFilterChange}
      />
      <ReusableTable columns={columns} data={boardData} loading={loading} onSort={handleSort}
        sortField={sortField}
        sortOrder={sortOrder} />
      <div className="flex justify-center mt-3">
        <div className="flex items-center gap-4">
          {/* <RowsPerPageDropdown
                        pageSize={pageSize}
                        onPageSizeChange={handlePageSizeChange}
                    /> */}
        </div>
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={handlePageChange}
          className="mt-2 mt-md-0"
          style={{
            display: 'flex',
            justifyContent: 'center',
          }}
        />
      </div>
      <BordAddandEditDialogComponent
        openDialog={openDialog}
        handleCloseDialog={handleCloseDialog}
        addDialogLoading={addDialogLoading}
        handleSubmit={handleSubmit}
        editData={editData}
        formData={formData}
        setFormData={setFormData}
        fields={licenseTypeFields}
        title={editData ? 'Edit License Type' : 'Add New License Type'}
      />
      <BordDeleteDialogComponent
        deleteDialog={deleteDialog}
        handleCloseDeleteDialog={handleCloseDeleteDialog}
        deleteLoading={deleteLoading}
        handleConfirmDelete={handleConfirmDelete}
        loading={deleteLoading}
      />
      <ActiveInactiveComponent
        isActive={toggleData?.isActive}
        setOpenToggle={setOpenToggle}
        handleConfirmToggle={handleConfirmToggle}
        loading={loading}
        openToggle={openToggle}
      />
    </div>
  )
}

export default LicenseType
